import { Button } from '@act/storybook';
import { Typography, Box, Divider } from '@mui/material';
import { ReactNode } from 'react';

export interface AdminToolSkeletonProps {
  title: string;
  toolDescription: string;
  buttonContent?: string;
  children?: ReactNode;
  onClick?: () => void;
  variant?: 'text' | 'outlined' | 'contained';
  startIcon?: ReactNode;
  disabled?: boolean;
}

export const AdminToolSkeleton = ({
  title,
  toolDescription,
  children,
  onClick,
  variant = 'outlined',
  startIcon,
  disabled = false,
  buttonContent,
}: AdminToolSkeletonProps) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        padding: '24px',
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        boxSizing: 'border-box',
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="24px"
        marginBottom="48px"
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          minWidth={'100px'}
          alignSelf="stretch"
          flexWrap="wrap"
        >
          <Typography variant="headlineMedium">{title}</Typography>
          {buttonContent && onClick && (
            <Button
              variant={variant}
              type="button"
              debounced
              onClick={onClick}
              sx={{
                padding: '12px 16px',
              }}
              disabled={disabled}
              startIcon={startIcon}
            >
              {buttonContent}
            </Button>
          )}
        </Box>
        <Box
          display="flex"
          paddingBottom="8px"
          flexDirection="column"
          alignItems="flex-start"
        >
          <Typography variant="titleMedium">{toolDescription}</Typography>
          <Divider />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          width="100%"
          gap="24px"
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
